﻿import React, {FC} from 'react';
import {SupplierActivitySummaryVo} from "../../../types/supplier/SupplierActivitySummaryVo";
import {
  CollapsableCardBodyContainer,
  CollapsableCardClickableContainer,
  CollapsableCardCollapseContainer,
  CollapsableCardContainer,
  CollapsableCardExpandIconButton,
  CollapsableCardHeaderActionsContainer,
  CollapsableCardHeaderContainer,
} from "@securspace/securspace-ui-kit";
import {
  CollapsableCardBodyItem,
  CollapsableCardHeaderItem
} from "../../cardComponents";

type SupplierActivitySummaryCardListItemProps = {
  activitySummary: SupplierActivitySummaryVo;
  collapse: boolean;
  onToggleCollapse: () => void;
}

/**
 * Component that displays all information for a single ActivitySummary
 * @param activitySummary the activitySummary to display
 * @param collapse variable to determine whether the collapsable part of the container is collapsed or not
 * @param onToggleCollapse callback that is called when the item should be toggled
 * @constructor
 */
const SupplierActivitySummaryCardListItem: FC<SupplierActivitySummaryCardListItemProps> = ({ activitySummary, collapse, onToggleCollapse }) => {
  return <CollapsableCardContainer expanded={collapse}>
    <CollapsableCardClickableContainer onClick={onToggleCollapse}>
      <CollapsableCardHeaderContainer>
        <CollapsableCardHeaderItem label={'LOCATION'} value={activitySummary.location} />
        <CollapsableCardHeaderItem label={'CURRENT INVENTORY'} value={activitySummary.currentInventory} />
        <CollapsableCardHeaderItem label={'MAX INVENTORY'} value={activitySummary.maxInventoryCount} />
        <CollapsableCardHeaderItem label={'CAPACITY'} value={activitySummary.capacity} />
        <CollapsableCardHeaderItem label={'MAX CAPACITY'} value={activitySummary.maxCapacity} />
        <CollapsableCardHeaderItem label={'BOOKED SPACES'} value={activitySummary.bookedSpaces ?? 0} />
        <CollapsableCardHeaderActionsContainer>
          <CollapsableCardExpandIconButton expanded={collapse} />
        </CollapsableCardHeaderActionsContainer>
      </CollapsableCardHeaderContainer>
    </CollapsableCardClickableContainer>
    <CollapsableCardCollapseContainer in={collapse}>
      <CollapsableCardBodyContainer>
        <CollapsableCardBodyItem label={'TOTAL MONTHLY BUYERS'} value={activitySummary.totalMonthlyCustomers} />
        <CollapsableCardBodyItem label={'TOTAL DAILY BUYERS'} value={activitySummary.totalDailyCustomers ?? 0} />
        <CollapsableCardBodyItem label={'OVERAGE SPACES'} value={activitySummary.overageSpaces ?? 0} />
        <CollapsableCardBodyItem label={'CHASSIS ONLY'} value={activitySummary.chassisOnly ?? 0} />
        <CollapsableCardBodyItem label={'CONTAINER EMPTY'} value={activitySummary.containerEmpty ?? 0} />
        <CollapsableCardBodyItem label={'CONTAINER LOADED'} value={activitySummary.containerLoaded ?? 0} />
        <CollapsableCardBodyItem label={'REEFERS'} value={activitySummary.reefers ?? 0} />
        <CollapsableCardBodyItem label={'IN GATES PAST 24 HOURS'} value={activitySummary.inGatesPast24Hours ?? 0} />
        <CollapsableCardBodyItem label={'OUT GATES PAST 24 HOURS'} value={activitySummary.outGatesPast24Hours ?? 0} />
      </CollapsableCardBodyContainer>
    </CollapsableCardCollapseContainer>
  </CollapsableCardContainer>
}

export { SupplierActivitySummaryCardListItem };
